import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const AuditListPage = lazy(() => import('./AuditListPage'));

export const auditRoutes: RouteObject[] = [
  {
    path: 'audit',
    element: (
      <ProtectedRoute action="audit:view">
        <AuditListPage />
      </ProtectedRoute>
    ),
  },
];
